import styled from 'styled-components';

export const Container = styled.div`
  min-height: 100vh;
  min-height: 100dvh;
  background: linear-gradient(180deg, #0a0e27 0%, #16213e 50%, #0a0e27 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 20px 24px;
  max-width: none !important;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 767px) {
    padding: 26px 14px 22px;
  }
`;

export const LogoWrapper = styled.div`
  display: block;
  margin-bottom: 14px;
  text-align: center;

  img {
    display: block;
    width: 120px;
    height: auto;
    margin: 0 auto;
  }
`;

export const Subtitle = styled.p`
  margin: 0 0 28px;
  color: rgba(208, 216, 236, 0.86);
  font-size: 0.95rem;
  line-height: 1.55;
  text-align: center;

  @media (max-width: 767px) {
    margin-bottom: 22px;
    font-size: 0.9rem;
  }
`;

export const Card = styled.div`
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  border-radius: 20px;
  padding: 40px 32px;
  width: 100%;
  max-width: 440px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(242, 146, 5, 0.2);
  border: 1px solid rgba(242, 146, 5, 0.2);

  @media (min-width: 768px) {
    width: 455px;
    max-width: 455px;
  }

  @media (max-width: 767px) {
    padding: 26px 18px 22px;
    border-radius: 18px;
  }
`;

export const Title = styled.h1`
  color: #ffffff;
  font-size: 24px;
  font-weight: 700;
  text-align: center;
  margin: 0 0 28px 0;
  text-shadow: 0 0 15px rgba(242, 146, 5, 0.3);

  @media (max-width: 767px) {
    font-size: 22px;
    margin-bottom: 22px;
  }
`;

export const FormWrapper = styled.div`
  .MuiFormControl-root {
    width: 100%;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  .MuiFormControl-root .MuiOutlinedInput-root {
    background: rgba(255, 255, 255, 0.05);
    border-radius: 10px;
    color: #ffffff !important;

    fieldset {
      border-color: rgba(255, 255, 255, 0.1);
    }

    &:hover fieldset {
      border-color: rgba(0, 212, 255, 0.3);
    }

    &.Mui-focused fieldset {
      border-color: #00d4ff;
    }
  }

  .MuiFormControl-root .MuiInputLabel-root {
    color: #b0b0b0 !important;

    &.Mui-focused {
      color: #00d4ff !important;
    }
  }

  .MuiInputBase-input {
    color: #ffffff !important;
  }

  .MuiInputAdornment-root .MuiIconButton-root svg,
  .MuiSvgIcon-root {
    color: #ffffff !important;
    fill: #ffffff !important;
  }

  .MuiFormHelperText-root.Mui-error {
    color: #ff8a8a !important;
    margin-left: 2px !important;
    margin-top: 6px !important;
  }

  .signin-submit.MuiButton-root {
    width: 100%;
    height: 52px;
    border-radius: 12px;
    font-weight: 700;
    font-size: 16px;
    background: linear-gradient(135deg, #f29205 0%, #ff6b35 100%);
    border: none;
    color: #ffffff;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 15px rgba(242, 146, 5, 0.3);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    text-transform: none;
  }

  .signin-submit.MuiButton-root:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(242, 146, 5, 0.4);
  }

  .signin-submit.MuiButton-root:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }

  @media (max-width: 767px) {
    .MuiOutlinedInput-root {
      height: 46px !important;
      min-height: 46px !important;
      align-items: center !important;
    }

    .MuiOutlinedInput-input {
      height: 46px !important;
      padding: 12px 14px !important;
      line-height: 1.2 !important;
      font-size: 14px !important;
    }

    .MuiInputLabel-outlined:not(.MuiInputLabel-shrink) {
      top: 50% !important;
      transform: translate(14px, -50%) scale(1) !important;
      line-height: 1.2 !important;
    }

    .MuiInputAdornment-root {
      margin-top: 0 !important;
      align-self: center !important;
    }

    .MuiInputAdornment-root .MuiIconButton-root {
      padding: 8px !important;
    }

    .signin-submit.MuiButton-root {
      height: 46px;
      font-size: 15px;
    }
  }
`;

export const DividerText = styled.p`
  color: #b0b0b0;
  font-size: 14px;
  text-align: center;
  margin: 24px 0 16px 0;

  &::before,
  &::after {
    content: '';
    display: inline-block;
    width: 60px;
    height: 1px;
    background: rgba(255, 255, 255, 0.2);
    vertical-align: middle;
    margin: 0 12px;
  }
`;

export const FooterLink = styled.p`
  text-align: center;
  margin: 24px 0 0 0;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  color: #b0b0b0;
  font-size: 14px;

  a {
    color: #f29205;
    font-weight: 600;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
      color: #ff6b35;
    }
  }
`;

export const CopyrightWrapper = styled.div`
  margin-top: auto;
  padding-top: 32px;
  color: #888;
  font-size: 13px;
  text-align: center;
`;

export const VideoContainer = styled.div`
  background-position: center;
  background-color: black;
  width: 90%;
  height: 230px;
  max-width: 387px;
  border-radius: 31px;
  border: 5px solid white;
  overflow: hidden;

  @media (max-width: 767px) {
    border-radius: 25px;
    border: 2px solid white;
    width: 50%;
    height: 174px;
    min-height: 174px;
    max-height: 174px;
    min-width: 318px;
    max-width: 318px;
  }
  
  @media (min-width: 769px) {
    border-radius: 25px;
    border: 2px solid white;
    height: 208px;
  }
`;
